<template>
  <LocaleProvider :locale="zhCN">
    <div ref="bigBoxNew">
      <div class="search-form">
        <div class="boxItem">
          <span class="boxTitle">菜单ID：</span>
          <Input v-model:value="searchForm.menuId" class="w-200" />
        </div>
        <div class="boxItem">
          <span class="boxTitle">操作时的菜单名称：</span>
          <Input v-model:value="searchForm.menuName" class="w-200" />
        </div>
        <div class="boxItem">
          <span class="boxTitle">当前最新的菜单名称：</span>
          <TreeSelect
            v-model:value="searchForm.selectMenuId"
            allow-clear
            class="w-200"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            :field-names="{
              children: 'children',
              value: 'id',
              label: 'text',
            }"
            :filter-tree-node="filterTreeNode"
            show-search
            :tree-data="JSON.parse(props.treeData)"
            tree-default-expand-all
            :tree-line="{ showLeafIcon: false }"
          />
        </div>
        <div class="boxItem">
          <span class="boxTitle">数据唯一键：</span>
          <Input v-model:value="searchForm.uniValue" class="w-200" />
        </div>
        <div class="boxItem">
          <span class="boxTitle">操作人：</span>
          <Input v-model:value="searchForm.userName" class="w-200" />
        </div>
        <div class="boxItem">
          <span class="boxTitle">操作时间
            <Tooltip title="时间范围最长支持90天！">
              <InfoCircleOutlined />
            </Tooltip>：
          </span>
          <RangePicker v-model:value="searchForm.opTime" class="w-400" show-time :allowClear="false" />
        </div>
        <div class="boxItem">
          <Button type="primary" @click="onSearch">
            查询
          </Button>
        </div>
        <div class="boxItem">
          <Button @click="onReset(searchForm,'pageNum','pageSize','opTime')">
            重置
          </Button>
        </div>
      </div>
      <div class="tips-yellow">
        触发流程审批的操作，审批通过时，才记录日志！
      </div>
      <Table :columns="columns" :data-source="JSON.parse(props.logData)" :pagination="false">
        <template #headerCell="{ column }">
          <template v-if="column.key === 'curMenuName'">
            <span>
              当前最新的菜单名称
              <Tooltip>
                <template #title>
                  <span>1. 菜单名称被修改时，当前最新的菜单名称≠操作时的菜单名称</span>
                  <br/>
                  <span>2. 为空时，表示该菜单已被删除</span>
                </template>
                <InfoCircleOutlined />
              </Tooltip>
            </span>
          </template>
          <template v-if="column.key === 'uniValue'">
            <span>
              数据唯一键
              <Tooltip title="显示格式：${主接口地址}?id=${数据表中记录的唯一键}">
                <InfoCircleOutlined />
              </Tooltip>
            </span>
          </template>
        </template>
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'uniValue'">
            {{ record.operation }}?{{ record.uniValue }}
          </template>
          <template v-if="column.key === 'operationType'">
            <span v-if="record.operationType === 'add'">增加</span>
            <span v-if="record.operationType === 'update'">修改</span>
            <span v-if="record.operationType === 'delete'">删除</span>
          </template>
          <template v-if="column.key === 'content'">
            <Button type="link" @click="initInfo(record)">
              查看
            </Button>
          </template>
          <template v-if="column.key === 'opTime'">
            {{ formatToTime(record.opTime) }}
          </template>
        </template>
      </Table>
      <Pagination
        v-model:current="searchForm.pageNum"
        v-model:pageSize="searchForm.pageSize"
        show-quick-jumper
        show-size-changer
        style="margin: 20px 0;float: right"
        :total="props.total"
        @change="changePage"
      />
      <Modal
        v-model:open="visible"
        title="操作内容"
        :width="1500"
        @cancel="handleClose"
        @ok="handleClose"
      >
        <diffOne v-if="ctx.needDiff === 0" v-bind="ctx" />
        <diffTwo v-else v-bind="ctx" />
      </Modal>
    </div>
  </LocaleProvider>
</template>

<script setup lang="ts">
import { defineEmits, defineProps, ref, onMounted } from 'vue'
import { formatToTime, getLastTimeRange } from './methods'
import {
  RangePicker,
  Button,
  Input,
  Modal,
  Pagination,
  Table,
  Tooltip,
  TreeSelect
} from "ant-design-vue";
// import Button from 'ant-design-vue/lib/button'
// import Input from 'ant-design-vue/lib/input'
// import Modal from 'ant-design-vue/lib/modal'
// import Pagination from 'ant-design-vue/lib/pagination'
// import Table from 'ant-design-vue/lib/table'
// import Tooltip from 'ant-design-vue/lib/tooltip'
// import TreeSelect from 'ant-design-vue/lib/tree-select'
import LocaleProvider from 'ant-design-vue/lib/locale-provider'
import { InfoCircleOutlined } from '@ant-design/icons-vue'
// import { type LogInfo, type Menu } from './type'
import { type LogInfo, type ISearchForm } from './type'
import diffOne from './components/diffOne.vue'
import diffTwo from './components/diffTwo.vue'
import zhCN from "ant-design-vue/es/locale/zh_CN";
// import dayjs from "dayjs";
// import "dayjs/locale/zh-cn";
// dayjs.locale("zh-cn");

const bigBoxNew = ref<HTMLDivElement>()
// const props = defineProps<{
//   total: number;
//   treeData: Menu[];
//   logData: LogInfo[]
// }>()
const props = defineProps<{
  total: number;
  treeData: string;
  logData: string
}>()
const emit = defineEmits(['update'])
const timeRange30 = getLastTimeRange(29, 0)
const searchForm = ref<ISearchForm>({
  menuId: undefined,
  menuName: undefined,
  selectMenuId: undefined,
  uniValue: undefined,
  userName: undefined,
  opTime: [timeRange30.startTime as unknown as number, timeRange30.endTime as unknown as number],
  opStartTime: undefined,
  opEndTime: undefined,
  pageNum: 1,
  pageSize: 10,
})
const visible = ref(false)
const columns = ref([
  { title: '菜单ID', dataIndex: 'menuId', key: 'menuId' },
  { title: '操作时的菜单名称', dataIndex: 'menuName', key: 'menuName' },
  { title: '当前最新的菜单名称', dataIndex: 'curMenuName', key: 'curMenuName' },
  { title: '数据唯一键', dataIndex: 'uniValue', key: 'uniValue' },
  { title: '操作类型', dataIndex: 'operationType', key: 'operationType' },
  { title: '操作内容', dataIndex: 'content', key: 'content' },
  { title: '操作人', dataIndex: 'userName', key: 'userName' },
  { title: '操作时间', dataIndex: 'opTime', key: 'opTime' },
])
const ctx = ref()

const filterTreeNode = (inputValue: string, treeNode: { text: string }) => {
  return `${treeNode.text}`.toLowerCase().includes(inputValue.toLowerCase())
}

const onSearch = () => {
  emit('update', searchForm.value)
}

const changePage = (page: number, pageSize: number) => {
  searchForm.value.pageNum = page
  searchForm.value.pageSize = pageSize
  emit('update', searchForm.value)
}
const initInfo = (record: LogInfo) => {
  ctx.value = record
  visible.value = true
}

const handleClose = () => {
  visible.value = false
}

const onReset = (obj:ISearchForm, pageNum:string, pageSize:string, opTime:string) => {
  Object.keys(obj).forEach(key => {
    console.log(key)
    if (key !== pageNum && key !== pageSize && key !== opTime) {
      obj[key] = undefined
    }
    if (key === pageNum) {
      obj[key] = 1
    }
  })
  emit('update', obj)
  return obj
}

onMounted(() => {
  document.querySelectorAll("style").forEach((item) => {
    if (item.getAttribute("data-cache-path")?.includes("rm38b5")) {
      bigBoxNew.value?.appendChild(item.cloneNode(true));
    }
    if (item.getAttribute("data-token-hash") === "rm38b5" || item.getAttribute("data-token-hash") === "1x4g4sz") {
      bigBoxNew.value?.appendChild(item.cloneNode(true));
    }
    if (item.getAttribute("data-css-hash")?.includes("1qb1s0s") || item.getAttribute("data-css-hash")?.includes("1hsjdkk")) {
      bigBoxNew.value?.appendChild(item.cloneNode(true));
    }
  });
});
</script>

<script lang="ts">
export default {
  name: "operation-log",
};
</script>

<style lang="less" scoped>
.search-form {
  display: flex;
  flex-wrap: wrap;
}

.boxItem {
  display: flex;
  align-items: baseline;
  margin: 10px;

  .boxTitle {
    font-size: 14px;
  }

  .w-200 {
    width: 200px;
  }

  .w-400 {
    width: 400px;
  }
}

.tips-yellow {
  margin-left: 10px;
  color: #faad14;
}
</style>
